// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"b573928e","176":"f0e742e0","453":"614ba3d0","501":"c8177f0f"}[chunkId] + ".chunk.js";
};